import { NavigationStackScreenComponent } from 'react-navigation-stack'
import React, { useEffect, useState } from 'react'
import { CustomHeader } from '../../components/CustomHeader'
import { formatMessage } from '../../constants/strings/intl/intlHooks'
import { messages } from '../../constants/strings/messages'
import { Coordinator } from '../../navigation/coordinator/coordinator'
import {
  ATLButton,
  ATLCheckbox,
  ATLDropdownSelector,
  ATLTextBody,
  ButtonTypeEnum,
  FontWeightEnum,
} from '@appsimples/atlantica-react-native'
import { icons } from '../../constants/searchAssets'
import { atlTheme } from '../../atlTheme'
import styled from 'styled-components/native'
import { FlatList } from 'react-native'
import { useGlobal } from '../../global/useGlobal'
import { usePromise } from '../../utils/hooks/usePromise'
import { getStatement } from '../../services/main/getStatement'
import { Loading } from '../../components/loading/Loading'
import { openWhatsApp } from '../../utils/openWhatsApp'
import { BRIO_SAC_WHATSAPP_NUMBER } from '../../constants/whatsAppInfo'
import { ifMoneyInt } from '../../utils/formatters'
import { shortMonth } from '../../constants/shortMonth'
import { getUserSaleContracts } from '../../services/main/getUserSaleContracts'

const TopWhiteCard = styled.ScrollView`
  background-color: ${atlTheme.ColorSurface};
  margin-vertical: ${atlTheme.SpacingAtomic}px;
  border-bottom-left-radius: ${atlTheme.BorderRadiusCard}px;
  border-bottom-right-radius: ${atlTheme.BorderRadiusCard}px;
`

const ButtonContainer = styled.View`
  width: 40%;
  align-self: center;
`

export const DuplicateScreen: NavigationStackScreenComponent = navigation => {
  const [installmentsOverdue] = useGlobal('installmentsOverdue')
  const [value, setValue] = useState([])
  const [duplicatedInstallment, setDuplicatedInstallment] = useState([])
  const [saleContractId, setSaleContractId] = useState<string>()
  const [userSaleContracts] = useGlobal('userSaleContracts')
  const [currentDropDownValue, setCurrentDropDownValue] = useState<string>('')
  const [dropdownUserSaleContractsData] = useGlobal('dropdownUserSaleContractsData')
  const [selectedUserSaleContract] = useGlobal('selectedUserSaleContract')

  const { loading: isGetConstructionsLoading, request: getConstructions } = usePromise(getUserSaleContracts)
  const { loading: isGetInfoLoading, request: getInfo } = usePromise(getStatement)

  useEffect(() => {
    getConstructions()
  }, [])

  useEffect(() => {
    setDuplicatedInstallment(installmentsOverdue.filter(installment => !installment.digitableNumber))
    const list = []
    duplicatedInstallment.forEach(() => list.push(false))
    setValue(list)
  }, [selectedUserSaleContract])

  if (currentDropDownValue === '') {
    if (selectedUserSaleContract) {
      setCurrentDropDownValue(selectedUserSaleContract.text)
      setSaleContractId(userSaleContracts[selectedUserSaleContract.id].id)
    } else {
      setCurrentDropDownValue(
        `${userSaleContracts[0]?.construction?.name} - ${userSaleContracts[0].constructionUnit?.name}` || ''
      )
      setSaleContractId(userSaleContracts[0].id)
    }
  }

  useEffect(() => {
    saleContractId && getInfo({ saleContractId: userSaleContracts[saleContractId]?.id })
  }, [saleContractId])

  const onSelectDropDown = item => {
    setSaleContractId(userSaleContracts[item?.id]?.id)
    setCurrentDropDownValue(item.text)
  }

  const onChange = async index => {
    const newArray = [...value]
    newArray[index] = !newArray[index]
    await setValue(newArray)
  }

  const onPressSAC = () => {
    let text = formatMessage(messages.financeDuplicateScreen_whatsApp_message)
    value.forEach((val, index) => {
      const betweenInstallments = val && index < value.length - 1
      const date = new Date(duplicatedInstallment[index]?.dueDate)
      const dateFormatted = shortMonth[date?.getMonth()].toUpperCase() + ' ' + date.getFullYear()
      text = val ? text.concat(`${duplicatedInstallment[index].conditionDescription} ${dateFormatted}\n`) : text
      text = betweenInstallments
        ? text.concat(formatMessage(messages.financeDuplicateScreen_whatsApp_message_and))
        : text
      text = val ? text.concat(`${currentDropDownValue}`) : text
    })
    openWhatsApp(text, BRIO_SAC_WHATSAPP_NUMBER)
  }

  const renderItem = (installment, index) => {
    const date = new Date(installment.dueDate)
    return (
      value && (
        <ATLCheckbox
          value={value[index]}
          onChange={() => onChange(index)}
          texts={[
            {
              text: `${installment?.conditionDescription ?? ''} ${shortMonth[
                date?.getMonth()
              ].toUpperCase()} ${date.getFullYear()} • ${ifMoneyInt(installment.currentBalance)}`,
            },
          ]}
          buttonToggleBaseProps={{ tintColor: atlTheme.ColorBrand2Default }}
        />
      )
    )
  }

  return isGetInfoLoading || isGetConstructionsLoading || !currentDropDownValue ? (
    <Loading />
  ) : (
    <TopWhiteCard>
      <ATLDropdownSelector
        value={currentDropDownValue}
        dropdownData={dropdownUserSaleContractsData}
        title={formatMessage(messages.financeBillsScreen_dropdown_title)}
        leftIcon={icons.towerIcon}
        horizontalMargin={atlTheme.SpacingMarginal}
        textInputBaseProps={{ leftIconColor: atlTheme.ColorBrand2Default }}
        onChange={onSelectDropDown}
      />
      <ATLTextBody
        labelBaseProps={{
          multilineLimit: 2,
          fontWeight: FontWeightEnum.medium,
          textColor: atlTheme.ColorHighContrast,
          fontSize: atlTheme.FontSizeHeading,
        }}
      >
        {formatMessage(messages.financeDuplicateScreen_selectInstallment)}
      </ATLTextBody>
      <FlatList
        data={duplicatedInstallment}
        renderItem={({ item, index }) => renderItem(item, index)}
        keyExtractor={item => item.installmentId.toString()}
      />
      <ButtonContainer>
        <ATLButton
          verticalMargin={atlTheme.SpacingMarginal}
          horizontalMargin={0.1}
          title={formatMessage(messages.financeDuplicateScreen_sendToSAC)}
          onPress={onPressSAC}
          type={ButtonTypeEnum.outlined}
          buttonBaseProps={{ borderRadius: atlTheme.BorderRadiusFloatingButton, fontWeight: FontWeightEnum.medium }}
          disabled={value.every(item => item === false)}
        />
      </ButtonContainer>
    </TopWhiteCard>
  )
}
DuplicateScreen.navigationOptions = CustomHeader(formatMessage(messages.financeDuplicateScreen_headerTitle), true, () =>
  Coordinator.goBack()
)
